import axios from 'axios'
import {baseURL} from '../utils/contract'
// import store from '../store/index'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset-utf-8'
const fetch = axios.create({
  // baseURL: process.env.VUE_APP_baseURL, // api 的 base_url
  baseURL,
  // withCredentials: true, // 默认的
  timeout: 120000 // request timeout
})
fetch.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    window.console.log('后台请求错误', error.response)
  }
)
// fetch.interceptors.request.use(
//   config => {
//   },
//   error => {
//     window.console.log('请求错误', error)
//   }
// )
const service = axios.create({
  baseURL, // api 的 base_url
  // baseURL: 'http://121.229.4.222:9002/zhcwsrv/infos', // api 的 base_url
  //baseURL: 'http://smc_api.moony.xyz:8888', 
  // baseURL: 'https://szshsurvey.com/',
  // baseURL: 'http://192.168.9.8:5001',
  // withCredentials: true,
  timeout: 60000 // request timeout
})
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    window.console.log('请求错误', error)
    return Promise.reject(new Error(error))
  }
)
service.interceptors.request.use( 
  request => {
    request.params = {
      ...request.params,
      tenant:1
    }
    return request
  },
  error => {
    window.console.log('请求错误', error)
    return Promise.reject(new Error(error))
  }
)
export default { fetch, service }
